
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Pagination extends Vue {
    @Prop({ default: 0 }) readonly total!: number;
    @Prop({ default: 1 }) readonly current!: number;

    get hasPrev () {
      return this.current > 1;
    }
    get hasNext () {
      return this.current < this.total;
    }

    goPrev () {
      if (this.hasPrev) {
        this.$emit('changePage', (this.current - 1));
      }
    }
    goNext () {
      if (this.hasNext) {
        this.$emit('changePage', (this.current + 1));
      }
    }
};
